<template>
  <div class="dish">
    <div class="image" ref="currentImage" :style="{'background-image': `url('${image}')`}" :class="{ 'use-contain': dish.image_use_contain }">
      <div class="promo-mark" v-if="dish.discount">-{{ dish.discount | money }} <rub /></div>
      <div class="size">{{ dish.size }}</div>
      <!--<img class="water-mark" v-if="dish.image" :src="require('@/assets/images/logo-white.svg')" />-->
    </div>
    <div class="title">{{ dish.post_title }}</div>
    <div class="subtitle" ref="subtitle" v-html="description" :class="{ 'need-collapse': needCollapse }" v-if="!giftMode"></div>
    <div class="bottom-row">
      <div class="price" v-if="!giftMode">{{ dish.price - dish.discount }} <rub :bold="true" /></div>
      <div class="gift-icon" v-else="giftMode"><svg-inline :src="require('@/assets/icons/gift.svg')" /></div>
      <div class="crossed-price" v-if="dish.discount || giftMode">{{ dish.price }} <rub :bold="true" /></div>
      <template v-if="!giftMode">
        <div class="button add-to-cart" v-if="!currentDishLine" @click="addCurrentToCart">В корзину</div>
        <quantity-selector
          v-else
          :amount="currentDishLine.quantity"
          @clickMinus="removeCurrentFromCart"
          @clickPlus="addCurrentToCart"
        />
      </template>
      <div class="button select-gift" :class="{ 'selected': giftSelected }" @click="$emit('selectGift')" v-else><svg-inline :src="require('@/assets/icons/check-circle.svg')" v-if="giftSelected" /><span>{{ giftSelected ? 'Выбрано' : 'Выбрать' }}</span></div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import QuantitySelector from '/src/components/QuantitySelector'
  import { find } from 'lodash'
  import Velocity from 'velocity-animate'

  export default {
    name: 'Dish',
    data () {
      return {
        maxLinesCount: 4,
        needCollapse: false,
        symbolsLimit: 90,
        description: ''
      }
    },
    props: {
      dish: {
        type: Object,
        required: true
      },
      giftMode: {
        type: Boolean,
        default: false
      },
      giftSelected: {
        type: Boolean,
        default: false
      }
    },
    components: {
      QuantitySelector
    },
    computed: {
      ...mapGetters({
        cartLines: 'cart/cartLines'
      }),
      currentDishLine () {
        return find(this.cartLines, (line) => {
          return line.id === this.dish.ID
        })
      },
      image () {
        return this.dish.image || require('@/assets/images/nophoto.jpg')
      }
      // description () {
      //   if (this.needCollapse) {
      //     let part = this.removeLastWord(this.dish.desc.substring(0, this.symbolsLimit))
      //     return part + '<span class="more-dots"> ...</span>'
      //   } else {
      //     return this.dish.desc
      //   }
      // }
    },
    methods: {
      ...mapActions({
        addToCart: 'cart/addToCart',
        removeFromCart: 'cart/removeFromCart'
      }),
      removeLastWord (str) {
        let lastIndex = str.lastIndexOf(' ')
        str = str.substring(0, lastIndex)
        return str
      },
      getCurrentLinesCount () {
        return Math.round(this.$refs.subtitle.offsetHeight / parseFloat(document.defaultView.getComputedStyle(this.$refs.subtitle).lineHeight))
      },
      cutToMaxLines () {
        let linesCount = this.getCurrentLinesCount()
        this.$refs.subtitle.setAttribute('data-lines', linesCount)
        if (linesCount > this.maxLinesCount) {
          this.needCollapse = true
          this.cutLinesIteration()
        }
      },
      cutLinesIteration () {
        this.description = this.removeLastWord(this.description)
        this.$nextTick(() => {
          let linesCount = this.getCurrentLinesCount()
          if (linesCount > this.maxLinesCount) {
            this.cutLinesIteration()
          } else {
            // let diff = this.dish.desc.substring(this.description.length)
            // this.description += '<span class="tail">' + diff + '</span>'
            this.description += '<span class="full">' + this.dish.desc + '</span>'
          }
        })
      },
      addCurrentToCart () {
        this.addToCart(this.dish.ID)
        if (!this.isSmartphone) {
          this.flyToHeaderCart()
        }
        this.sendSimpleEvent({ category: 'Test', action: 'AddToCart', label: this.dish.post_title, value: this.currentDishLine.quantity })
      },
      flyToHeaderCart () {
        let currentImage = this.$refs.currentImage
        let currentLeft = window.scrollX + currentImage.getBoundingClientRect().left
        let currentTop = window.scrollY + currentImage.getBoundingClientRect().top

        let flyingImage = document.createElement('div')
        flyingImage.classList.add('flying-image')
        flyingImage.style.backgroundImage = 'url(\'' + this.image + '\')'
        flyingImage.style.left = currentLeft
        flyingImage.style.top = currentTop
        flyingImage.style.width = currentImage.offsetWidth
        flyingImage.style.height = currentImage.offsetHeight
        if (this.dish.image_use_contain) {
          flyingImage.classList.add('use-contain')
        }
        document.body.appendChild(flyingImage)

        let headerCart = document.querySelector('#site-header .header-cart')
        let deltaX = window.scrollX + headerCart.getBoundingClientRect().left - currentLeft
        let deltaY = window.scrollY + headerCart.getBoundingClientRect().top - currentTop

        Velocity(flyingImage, {
          translateX: deltaX,
          translateY: deltaY,
          scale: 0.6,
          opacity: 0.6
        }, {
          duration: 750,
          easing: 'ease-in-out',
          complete: () => {
            flyingImage.remove()
          }
        })
      },
      removeCurrentFromCart () {
        this.removeFromCart(this.dish.ID)
      }
    },
    mounted () {
      this.description = this.dish.desc
      if (!this.isSmartphone && !this.giftMode) {
        this.$nextTick(() => {
          this.cutToMaxLines()
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Dish.vue